export const listCustomers = `
   query listCustomers($filter: CustomersFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listCustomers(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              name
              description
              status
              contactInfo {
                  email
                  phone
                  website
              }
              created
              createdByUsername
              createdByUser {
                name
                givenName
                familyName
                email
              }
              updated
              updatedByUsername
           }
           nextToken
       }
   }
`;

export const getCustomer = `
   query getCustomer($id:ID!) {
       getCustomer(id:$id) {
         id
         name
         description
         status
         contactInfo {
           email
           phone
           website
         }
         created
         createdByUsername
         createdByUser {
            name
            givenName
            familyName
            email
         }
         updated
         updatedByUsername
       } 
}`;
